import useSWR from "swr";

import fetchJSON from "@lib/fetch-json";

export const useSync = (oid: string | undefined): void => {
  useSWR(oid && `/api/v1/users/${oid}/sync`, fetchJSON, {
    revalidateOnFocus: false,
  });
};
